import React from 'react'
import PropTypes from 'prop-types'
import { defaultFontFamily } from 'design-system/constants'

export const renderNode = ({ attributes, children, node }) => {
  switch (node.type) {
    case 'block-quote':
      return <blockquote {...attributes}>{children}</blockquote>
    case 'bulleted-list':
      return <ul {...attributes}>{children}</ul>
    case 'heading-one':
      return <h1 {...attributes}>{children}</h1>
    case 'heading-two':
      return <h2 {...attributes}>{children}</h2>
    case 'list-item':
      return <li {...attributes}>{children}</li>
    case 'numbered-list':
      return <ol {...attributes}>{children}</ol>
    default:
      return null
  }
}

renderNode.propTypes = {
  attributes: PropTypes.object.isRequired,
  children: PropTypes.object.isRequired,
  node: PropTypes.object.isRequired,
}

export const renderMark = ({ children, mark }) => {
  switch (mark.type) {
    case 'bold':
      return <span style={{ fontFamily: defaultFontFamily }}>{children}</span>
    case 'code':
      return <code>{children}</code>
    case 'italic':
      return <em>{children}</em>
    case 'underline':
      return <u>{children}</u>
    default:
      return null
  }
}

renderMark.propTypes = {
  children: PropTypes.object.isRequired,
  mark: PropTypes.object.isRequired,
}
